module.exports = __webpack_public_path__ + "img/car-wash.04528ece.svg";